import { useEffect, useState } from "react";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../../context/AlertContext";
import AuthService from "../../../../../../api/AuthService";
import { useLocation, useNavigate } from "react-router-dom";
import CreateSalesOrderPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/SalesOrder/CreateSalesOrder";
import AssetCreateaPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/AssetsManagement/CreateAssets";
import AssetsViewPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/AssetsManagement/ViewAssets";

const AssetsView = () => {
  const [singleAssetData, setSingleAssetData] = useState({});
  const [depreciationForcastList, setDepreciationForcastList] = useState([]);
  const location = useLocation();
  const { showAlert } = useAlert();
  const navigate = useNavigate()
  const item = location?.state?.item || {};

  useEffect(() => {
    getOneAsset(item._id);
  }, []);

  const getOneAsset = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetOneData(id);
      if (result?.success) {
        setSingleAssetData(result?.data?.asset);
        setDepreciationForcastList(result?.data?.depreciationForecast);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDeleteAsset(id);
      if (result?.success) {
        showAlert("Asset deleted successfully", "success")
        LoaderHelper.loaderStatus(false);
        navigate('/dashboard/assetsHome')
      } else {
        showAlert(result.message, "error")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <AssetsViewPage
      singleAssetData={singleAssetData}
      handleDelete={handleDelete}
      depreciationForcastList={depreciationForcastList}
    />
  )
};
export default AssetsView;
